import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import { Trash2 } from 'lucide-react'
import useMutationDeleteMember from '@/modules/manage-member/api/hooks/useMutateDeleteMember'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import { useQueryClient } from '@tanstack/react-query'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'
import { useIsCurrentUser } from '@/modules/manage-member/hooks/useIsCurrentUser'

interface DeleteMemberModalProps {
	id: string
}

export default function DeleteMemberModal({ id }: DeleteMemberModalProps) {
	const queryClient = useQueryClient()
	const { mutateAsync: deleteMember } = useMutationDeleteMember()
	const isCurrentUser = useIsCurrentUser(id)

	if (isCurrentUser) {
		return null
	}

	const handleDelete = async () => {
		try {
			await deleteMember({ id })
			toast.success('ลบสมาชิกสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [OperatorQueryKeys.GetMemberList],
			})
		} catch (error) {
			showErrorToast(error as Error)
		}
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ลบสมาชิก</AlertDialogTitle>
					<AlertDialogDescription>
						คุณต้องการลบสมาชิกนี้ใช่หรือไม่?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ยืนยัน</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
